/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_Label_HelpInputs */

const en_tokens_label_help = /** @type {(inputs: Tokens_Label_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you’ll recognise it, e.g. the device.`)
};

const de_tokens_label_help = /** @type {(inputs: Tokens_Label_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woran du das Token erkennst, z. B. das Gerät.`)
};

/**
* | output |
* | --- |
* | "How you’ll recognise it, e.g. the device." |
*
* @param {Tokens_Label_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_label_help = /** @type {((inputs?: Tokens_Label_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_Label_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_label_help(inputs)
	return en_tokens_label_help(inputs)
});